import type { LoadingUnloadingAllocationLink } from './loadingUnloadingLinkHelpers';
import {
  isSequentialStopsSaveShadowDebugEnabled
} from './sequentialStopsSaveFlags';
import type { RouteStopSaveRow } from './routeStopsSavePipeline';

function rowSignature(rows: RouteStopSaveRow[]): string {
  return rows
    .map(
      (r) =>
        `${r._stopUid ?? '?'}:${r.type}@${r.position}:p${r.parentLoadingPosition ?? '-'}`
    )
    .join('|');
}

function linksSignature(links: LoadingUnloadingAllocationLink[]): string {
  return links.map((l) => `${l.fromLoadingPosition}->${l.toUnloadingPosition}`).join('|');
}

export function logSequentialStopsSaveShadow(params: {
  routeId?: number;
  legacyRows: RouteStopSaveRow[];
  sequentialRows: RouteStopSaveRow[];
  allocationLinks?: LoadingUnloadingAllocationLink[];
  usedBuilder: 'legacy' | 'sequential' | 'sequential-fallback-legacy';
}): void {
  if (!isSequentialStopsSaveShadowDebugEnabled()) return;

  const legacySig = rowSignature(params.legacyRows);
  const seqSig = rowSignature(params.sequentialRows);
  const diverges = legacySig !== seqSig;

  // eslint-disable-next-line no-console
  console.debug('[SequentialStopsSave][shadow]', {
    routeId: params.routeId,
    usedBuilder: params.usedBuilder,
    diverges,
    legacyOrder: legacySig,
    sequentialOrder: seqSig,
    legacyPositions: params.legacyRows.map((r) => ({
      uid: r._stopUid,
      position: r.position,
      parentLoadingPosition: r.parentLoadingPosition
    })),
    sequentialPositions: params.sequentialRows.map((r) => ({
      uid: r._stopUid,
      position: r.position,
      parentLoadingPosition: r.parentLoadingPosition
    })),
    allocationLinks: params.allocationLinks ? linksSignature(params.allocationLinks) : undefined
  });
}
